import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./Question.scss";

// NOTE this template can render without data for a placeholder, so if you
// modify it, make sure you do safety checks around your vars!
const Question = (props) => {
	const { category, text, answer } = props;

	const imageClasses = classnames({
		"important-question-image": true,
		[`category-${category}`]: !!category,
	});

	return (
		<div className="important-question">
			<div className={imageClasses}>
				{category &&
					<span>
						<span className="important-question-image-text">
							{category}
						</span>
						<div className="important-question-image-icon" />
					</span>
				}
			</div>
			{(text || answer) &&
				<div className="important-question-content">
					{text &&
						<span className="important-question-text">
							{text}
						</span>
					}
					{answer &&
						<span className="important-question-answer">
							They said:
							{" "}
							<span className="important-question-answer-text">
								{answer}
							</span>
						</span>
					}
				</div>
			}
		</div>
	);
};

Question.propTypes = {
	category: PropTypes.string,
	text: PropTypes.string,
	answer: PropTypes.string,
};

export default Question;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/headers/ImportantQuestions/Question.jsx